import React from "react";

// STYLES
import * as Style from "./TableStyle";

// LIBRARIES
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";

// MISC
import { TableConfigData } from "config/TableConfigData";
import { ButtonTypes, ModalTypes, NewcomeUserStatus, Tabs } from "models/GeneralTypes/generalTypes";
import {
  IFilters
} from "models/interfaces";
import { IProps } from "./TableModel";
import { COLORS } from "constants/styleVariables";

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { selectedTab, toggleModalState } from "slices/uiSlice";
import { filters, handlePageChange } from "slices/filtersSlice";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import Pagination from "components/TablePagination/TablePagination";
import ToggleArrows from "components/ToggleArrows/ToggleArrows";

const DynamicTable = (props: IProps) => {
  // PROPS
  const { tableData = {}, totalPages = 0 } = props;

  // CONSTANTS USING LIBRARIES
  const activeTab = useAppSelector<string>(selectedTab);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const filtersData = useAppSelector<IFilters>(filters);

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS
  const { tableConfig } = TableConfigData();

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleOpen = (row) => {
    if (activeTab === Tabs.RENTALS) {
      dispatch(
        toggleModalState({
          isVisible: true,
          type: ModalTypes.RENTAL,
          rental: row,
        })
      );
    } else if (activeTab === Tabs.RENTALS_LOGS && row.rentalId) {
      dispatch(
        toggleModalState({
          isVisible: true,
          type: ModalTypes.RENTAL,
          rental: row,
        })
      );
    } else if (activeTab === Tabs.SMS_LOGS && row.id) {
      dispatch(
        toggleModalState({
          isVisible: true,
          type: ModalTypes.USER,
          user: row,
        })
      );
    } else if (activeTab === Tabs.USERS && row.id) {
      dispatch(
        toggleModalState({
          isVisible: true,
          type: ModalTypes.EDIT_USER_STATUS,
          user: row,
        })
      );
    }
  };

  return (
    <Style.TableContainer>
      <Style.TableWrapper>
        <Style.MUITable>

          <Style.MUITableHead>

            <Style.MUIHeadTableRow>
              {activeTab &&
                tableConfig[activeTab]?.columns.map((item) => {
                  if (!item.hasAction) {
                    return (
                      <Style.MUITableCell orientation={item?.orientation || ""}>
                        {item?.label || ""}
                        {item?.hasToggle && <ToggleArrows />}

                      </Style.MUITableCell>
                    )
                  } else {
                    return (
                      <Style.MUITableCell orientation={item?.orientation || ""}>
                        {item?.label || ""}
                      </Style.MUITableCell>
                    )
                  }

                })}
            </Style.MUIHeadTableRow>

          </Style.MUITableHead>

          <Style.RowSpace />

          <Style.MUITableBody>

            {tableData.map((row) => (
              <React.Fragment>
                <Style.MUITableRow>
                  {tableConfig[activeTab]?.columns.map((item) => {
                    if (!item.hasAction) {
                      if (item?.key === "userStatus") {
                        return (
                          <Style.MUITableCell
                            orientation={item?.orientation || ""}
                          >

                            <Tooltip title={row[item?.key || ""] || ""} arrow>
                              <Style.StatusContainer>
                                <Style.Dot color={
                                  row?.[item?.key] === NewcomeUserStatus.VERIFIED ? COLORS.primaryGreen : COLORS.terraCotta} />
                                <Style.StatusValue color={
                                  row?.[item?.key] === NewcomeUserStatus.VERIFIED ? COLORS.primaryGreen : COLORS.terraCotta}>
                                  {t(`user.status.${row?.[item?.key]}`) || ""}
                                </Style.StatusValue>
                              </Style.StatusContainer>
                            </Tooltip>

                          </Style.MUITableCell>
                        )
                      } else
                        return (
                          <Style.MUITableCell
                            orientation={item?.orientation || ""}
                          >

                            <Tooltip title={row[item?.key || ""] || ""} arrow>
                              <Style.TextContainer>
                                {row[item?.key || ""] || ""}
                              </Style.TextContainer>
                            </Tooltip>

                          </Style.MUITableCell>
                        )
                    }
                    else return <>
                      <Style.MUIActionTableCell
                        orientation={item?.orientation || ""}
                      >
                        {
                          activeTab === Tabs.USERS ? <>
                            <ButtonAtom
                              onClick={() => handleOpen(row)}
                              type={ButtonTypes.ICON_BUTTON_EDIT}
                            />
                          </> :
                            <ButtonAtom
                              onClick={() => handleOpen(row)}
                              type={ButtonTypes.ICON_BUTTON_HISTORY}
                            />
                        }
                      </Style.MUIActionTableCell>
                    </>;
                  })}
                </Style.MUITableRow>

              </React.Fragment>
            ))}
          </Style.MUITableBody>
        </Style.MUITable>
      </Style.TableWrapper>
      {tableConfig[activeTab].metadata.isPageable &&
        <Style.PaginationWrapper>


          <Pagination
            onChange={(e, newPage) => {
              dispatch(handlePageChange((newPage - 1)));
            }}
            totalPage={totalPages}
            currentPage={Number(filtersData.page)}
          />
        </Style.PaginationWrapper>
      }
    </Style.TableContainer>
  );
};

export default DynamicTable;
